import isEmpty from 'lodash-es/isEmpty';
import findLastIndex from 'lodash-es/findLastIndex';

import { ReservationItems, ReservationType, UserHistoryItem } from '@user-history/entities/user-history-item';
import { getDefaultFlightReservations } from '@user-history/mappers/flight-reservations.mapper';
import { isConfirmReservationByStatus } from '@ux/mappers/reservation-status.mapper';

export function getReservationItem(item: UserHistoryItem): ReservationItems[] {
  const reservations = item?.ReservationItems?.filter(_res => _res.ReservationItemType !== ReservationType.Assistance) || [];
  const defaultItem = reservations;
  const reservationItemValue = defaultItem[0]?.ReservationItemType === ReservationType.Flight ?
    getFlightReservationItem(reservations) : defaultItem;
  return reservationItemValue;
}

export function getReservationItemByExtra(item: UserHistoryItem): ReservationItems {
  const reservations = item?.ReservationItems?.filter(_res => _res.ReservationItemType !== ReservationType.Extra) || [];
  return getReservationItem({ ...item, ReservationItems: reservations })[0];
}

export function getDetaultExtraItem(item: UserHistoryItem): ReservationItems {
  const reservations = item?.ReservationItems?.filter(_res => _res.ReservationItemType === ReservationType.Extra) || [];
  const defaultReturn = {} as ReservationItems;
  return reservations.length ? (
    reservations.length > 1 ? getConfirmReservationByItem(reservations) as ReservationItems :
      (reservations.length === 1 ? reservations[0] : defaultReturn)
  ) : defaultReturn;
}

function getConfirmReservationByItem(reservations: ReservationItems[]): ReservationItems {
  const defaultReturn = {} as ReservationItems;
  const lastConfirmIndex = findLastIndex(reservations as ReservationItems[], (item: ReservationItems) =>
    isConfirmReservationByStatus(item.ReservationStatus));
  return lastConfirmIndex >= 0 ? reservations[lastConfirmIndex] : defaultReturn;
}

function getFlightReservationItem(reservations: ReservationItems[]): ReservationItems[] {
  const defaultReservation = getDefaultFlightReservations(reservations, true) as ReservationItems[];
  return !isEmpty(defaultReservation) ? defaultReservation : [] as ReservationItems[];
}
